export default {
    auth: {
        isLoggedIn: false,
        currentUser: null,
        loginAsUser: null,
        loginAttemptFailed: false
    }
}